import React from "react"
import { Link } from "gatsby"
import tw, { styled, theme } from "twin.macro"

import PressBadgeIcon from "images/icons/press-badge.inline.svg"

const PressMoreInfoStyles = styled(Link)`
  ${tw`flex-row items-center justify-center`}

  svg {
    width: 30px;
    height: 30px;

    path {
      fill: ${theme`colors.yellow`};
    }
  }

  &.footer {
    svg {
      path {
        fill: ${theme`colors.neonred`};
      }
    }
  }
`

const PressMoreInfo = ({ className = "" }) => {
  return (
    <PressMoreInfoStyles className={className} to="/newsroom">
      <PressBadgeIcon />
      <span className="ml-2 normal-case text-sm leading-none font-body">
        Journalist?&nbsp;<span className="underline">More info</span>
      </span>
    </PressMoreInfoStyles>
  )
}

export default PressMoreInfo
